import { IconChevronDown } from '@tabler/icons-react'
import { components, DropdownIndicatorProps } from 'react-select'

import { AstraIcon } from '../../../AstraIcon/AstraIcon'
import { SelectOption, SelectOptionGroup } from '../types'

export const dropdownIndicatorClassName = () => '!p-0'

export function DropdownIndicator<T>(props: DropdownIndicatorProps<SelectOption<T>, false, SelectOptionGroup<T>>) {
    return (
        <components.DropdownIndicator {...props}>
            <AstraIcon icon={IconChevronDown} color={props.isDisabled ? 'text-disabled' : undefined} />
        </components.DropdownIndicator>
    )
}
